import { useEffect, useState } from "react";

const DEFAULT_POPUP_EXIT_MS = 180;

export function usePopupPresence(
  open: boolean,
  exitMs = DEFAULT_POPUP_EXIT_MS,
) {
  const [mounted, setMounted] = useState(open);

  useEffect(() => {
    if (open) {
      setMounted(true);
      return;
    }

    const timer = window.setTimeout(() => setMounted(false), exitMs);
    return () => window.clearTimeout(timer);
  }, [exitMs, open]);

  return {
    mounted: open || mounted,
    state: open ? "open" : "closed",
  } as const;
}
